import { useMemo } from 'react';
import { NextPage } from 'next';

import { PageSection } from 'types/pages';
import { Routes } from 'types/routes';

import { withVariables } from 'utils/string';

import Head from 'components/layout/Head';
import PageContainer from 'components/layout/PageContainer';
import SectionsWrapper from 'components/layout/SectionsWrapper';
import WrapperPublic from 'components/wrappers/Public';

import SectionNewsletter from '../Home/sections/Newsletter';

import SectionCta from './sections/Cta';
import SectionHero from './sections/Hero';
import SectionPlans from './sections/Plans';
import StyledComponent from './styles';
import { Props } from './types';

const PagePlans: NextPage<Props> = ({ pageTranslations, plans }) => {
    const sections: PageSection[] = useMemo(() => [{
        slug: 'hero',
        order: 1,
        isVisible: true,
        children: (slug, translations) => (
            <SectionHero
                key={slug}
                translations={translations}
            />
        ),
    }, {
        slug: 'plans',
        order: 2,
        isVisible: true,
        children: (slug, translations) => (
            <SectionPlans
                key={slug}
                plans={plans}
                translations={translations}
            />
        ),
    }, {
        slug: 'cta',
        order: 3,
        isVisible: true,
        children: (slug, translations) => (
            <SectionCta
                key={slug}
                translations={translations}
            />
        ),
    }, {
        slug: 'newsletter',
        order: 5,
        isVisible: true,
        children: (slug, translations) => (
            <SectionNewsletter
                key={slug}
                translations={translations}
            />
        ),
    }], []);

    return (
        <WrapperPublic>
            <StyledComponent className="page-plans">
                <Head
                    title={pageTranslations?.page?.metaTitle}
                    description={pageTranslations?.page?.metaDescription}
                    canonical={withVariables(Routes.PublicCourses)}
                />
                <PageContainer>
                    <SectionsWrapper
                        sections={sections}
                        localTranslations={pageTranslations?.sections}
                        enabledStates={pageTranslations?.sectionsEnabled}
                    />
                </PageContainer>
            </StyledComponent>
        </WrapperPublic>
    );
};

export default PagePlans;
